import React from 'react';
import styled, {css} from 'styled-components';
import PropTypes from 'prop-types';
import SelectOptions from '../../components/Common/ButtonGroup';

/**
 *  Button Group components
 */
function GroupOptions({
  className,
  options,
  styles,
  onActiveCallback,
  selectedDefault,
}) {
  return (
      <div className={className}>
        {
          options.map((o, i) => (
            <SelectOptions
              activeDefault={{ name: o.name, value: selectedDefault[i] }}
              onActiveCallback={onActiveCallback}
              styles={styles}
              option={o}
              key={o.position}
            />
          ))
        }
      </div>
  );
}

const StyledProductOptions = styled(GroupOptions)`
  display: flex;
  flex-direction: column;
  padding: 10px 0;
`;

/**
 * ProductOptions components
 */
export default class ProductOptions extends React.PureComponent {
  render() {
    const {
      styles,
      options,
      defaultOptions,
      onActiveCallback,
    } = this.props;
    return (
      <StyledProductOptions
        options={options}
        selectedDefault={defaultOptions}
        styles={{
          active_background_color: styles.optionsStyle.hover.backgroundColor,
          active_color: styles.optionsStyle.hover.color,
          hover_color: styles.optionsStyle.hover.backgroundColor,
        }}
        onActiveCallback={onActiveCallback}
      />
    );
  }
}

ProductOptions.propTypes = {
  options: PropTypes.arrayOf(Object),
  styles: PropTypes.any,
  defaultOptions: PropTypes.arrayOf(String),
};
